/**
 * Elevation styles for CSS box-shadow property.
 * KM Carbon: https://carbon.googleplex.com/kaggle/pages/elevation
 * GM2 Carbon: https://carbon.googleplex.com/google-material/pages/elevation
 *
 * Usage example:
 *
 * const ElevatedDiv = styled.div`
 *   box-shadow: ${(theme) => theme.km.elevation[1]};
 * `
 */ var themedElevationBoxShadow = {
    light: {
        1: "0 1px 2px 0 rgba(60,64,67,0.30), 0 1px 3px 1px rgba(60,64,67,0.15)",
        2: "0 1px 2px 0 rgba(60,64,67,0.30), 0 2px 6px 2px rgba(60,64,67,0.15)",
        3: "0 1px 3px 0 rgba(60,64,67,0.30), 0 4px 8px 3px rgba(60,64,67,0.15)",
        4: "0 2px 3px 0 rgba(60,64,67,0.30), 0 6px 10px 4px rgba(60,64,67,0.15)",
        5: "0 4px 4px 0 rgba(60,64,67,0.30), 0 8px 12px 6px rgba(60,64,67,0.15)"
    },
    dark: {
        1: "0 1px 2px 0 rgba(0,0,0,0.30), 0 1px 3px 1px rgba(0,0,0,0.15)",
        2: "0 1px 2px 0 rgba(0,0,0,0.30), 0 2px 6px 2px rgba(0,0,0,0.15)",
        3: "0 1px 3px 0 rgba(0,0,0,0.30), 0 4px 8px 3px rgba(0,0,0,0.15)",
        4: "0 2px 3px 0 rgba(0,0,0,0.30), 0 6px 10px 4px rgba(0,0,0,0.15)",
        5: "0 4px 4px 0 rgba(0,0,0,0.30), 0 8px 12px 6px rgba(0,0,0,0.15)"
    }
};
/**
 * Elevation background color styles for CSS background-color property.
 * GM2 Carbon: http://shortn/_er3YKnchws
 *
 * These are mainly used by FABs (floating action buttons), see b/199174989.
 *
 * Usage example:
 *
 * const FloatingActionButton = styled.button`
 *   box-shadow: ${({ theme }) => theme.km.elevation[2]};
 *   background-color: ${({ theme }) => theme.km.elevationBackgroundColor[2]};
 * `
 */ var themedElevationBackgroundColor = {
    light: {
        1: "transparent",
        2: "transparent",
        3: "transparent",
        4: "transparent",
        5: "transparent"
    },
    dark: {
        1: "rgba(232,234,237,0.05)",
        2: "rgba(232,234,237,0.08)",
        3: "rgba(232,234,237,0.11)",
        4: "rgba(232,234,237,0.12)",
        5: "rgba(232,234,237,0.14)"
    }
};
export function getElevation(themeName) {
    return {
        boxShadow: themedElevationBoxShadow[themeName],
        backgroundColor: themedElevationBackgroundColor[themeName]
    };
}
